import Image from 'next/image';
import { useTranslation } from 'react-i18next';
import styles from '../../HomepageSections.module.scss';
import { SectionHeading } from '../shared/SectionHeading';

export const CoverageSection = () => {
  const { t } = useTranslation('landing');

  return (
    <section className={styles.coverageSection} id='countries'>
      <div className={styles.wideShell}>
        <div className={styles.coverageHeader}>
          <SectionHeading eyebrow={t('homepage.coverage.eyebrow')} title={t('homepage.coverage.title')} />
          <div className={styles.regionPills} aria-label={t('homepage.coverage.regionsLabel')}>
            {['EU', 'APAC', 'EMEA'].map((region) => (
              <span key={region}>{region}</span>
            ))}
          </div>
        </div>
        <div className={styles.mapFrame}>
          <Image
            className={styles.countryCoverageMap}
            src='/images/maps/country-coverage.svg?v=4'
            alt={t('homepage.coverage.mapAlt')}
            width={1375}
            height={731}
          />
        </div>
        <div className={styles.roadmap}>
          <article>
            <span>{t('homepage.coverage.milestones.today.title')}</span>
            <p>{t('homepage.coverage.milestones.today.description')}</p>
          </article>
          <article>
            <span>{t('homepage.coverage.milestones.france.title')}</span>
            <p>{t('homepage.coverage.milestones.france.description')}</p>
          </article>
          <article>
            <span>{t('homepage.coverage.milestones.uae.title')}</span>
            <p>{t('homepage.coverage.milestones.uae.description')}</p>
          </article>
        </div>
      </div>
    </section>
  );
};
